import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _createOrUpdateMapperRequest = {};
var _createOrUpdateMapperResponse = {};
var _deleteEntityMapperRequest = {};
var _deleteEntityMapperResponse = {};
var _deleteMapperRequest = {};
var _deleteMapperResponse = {};
var _getEntityMapperRequest = {};
var _getEntityMapperResponse = {};
var _getMapperRequest = {};
var _getMapperResponse = {};
var _getSubscribedTopicsRequest = {};
var _getSubscribedTopicsResponse = {};
var _listMappersRequest = {};
var _listMappersResponse = {};
var _publishSiteTranslationsRequest = {};
var _publishSiteTranslationsResponse = {};
var _stressDMRequest = {};
var _stressDMResponse = {};
var _syncEditorDataRequest = {};
var _syncEditorDataResponse = {};
function resolveWixMultilingualEditoradapterV1EditorAdapterUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/editoradapter/v1/component-mapper',
                destPath: '/v1',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressMultilingualNilewrapperLocalizationNileWrapperUrl(opts) {
    var domainToMappings = {};
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Returns a mapper of a given entity */
export function getEntityMapper(payload) {
    var _a = serializer(_getEntityMapperRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getEntityMapperResponse, {}).fromJSON;
    function __getEntityMapper(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.multilingual.genericconverter.v1.entity_mapper',
            method: 'GET',
            methodFqn: 'com.wixpress.multilingual.nilewrapper.LocalizationNileWrapper.GetEntityMapper',
            url: resolveComWixpressMultilingualNilewrapperLocalizationNileWrapperUrl({
                protoPath: '/v1/entity_mapper',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getEntityMapper.fromReq = fromReq;
    return __getEntityMapper;
}
getEntityMapper.__isAmbassador = true;
/** Deletes a mapper of a given entity */
export function deleteEntityMapper(payload) {
    var _a = serializer(_deleteEntityMapperRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteEntityMapperResponse, {}).fromJSON;
    function __deleteEntityMapper(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.multilingual.genericconverter.v1.entity_mapper',
            method: 'DELETE',
            methodFqn: 'com.wixpress.multilingual.nilewrapper.LocalizationNileWrapper.DeleteEntityMapper',
            url: resolveComWixpressMultilingualNilewrapperLocalizationNileWrapperUrl({
                protoPath: '/v1/entity_mapper',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteEntityMapper.fromReq = fromReq;
    return __deleteEntityMapper;
}
deleteEntityMapper.__isAmbassador = true;
/** Returns a list of subscribed topics */
export function getSubscribedTopics(payload) {
    var _a = serializer(_getSubscribedTopicsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSubscribedTopicsResponse, {}).fromJSON;
    function __getSubscribedTopics(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.multilingual.genericconverter.v1.entity_mapper',
            method: 'GET',
            methodFqn: 'com.wixpress.multilingual.nilewrapper.LocalizationNileWrapper.GetSubscribedTopics',
            url: resolveComWixpressMultilingualNilewrapperLocalizationNileWrapperUrl({
                protoPath: '/v1/subscribed-topics',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSubscribedTopics.fromReq = fromReq;
    return __getSubscribedTopics;
}
getSubscribedTopics.__isAmbassador = true;
/** Update localization content with editor data */
export function syncEditorData(payload) {
    var _a = serializer(_syncEditorDataRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_syncEditorDataResponse, {}).fromJSON;
    function __syncEditorData(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.multilingual.genericconverter.v1.entity_mapper',
            method: 'GET',
            methodFqn: 'wix.multilingual.editoradapter.v1.EditorAdapter.SyncEditorData',
            url: resolveWixMultilingualEditoradapterV1EditorAdapterUrl({
                protoPath: '/v1/pull_data',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __syncEditorData.fromReq = fromReq;
    return __syncEditorData;
}
syncEditorData.__isAmbassador = true;
/** Update publish content in editor with the latest saved content */
export function publishSiteTranslations(payload) {
    var _a = serializer(_publishSiteTranslationsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_publishSiteTranslationsResponse, {}).fromJSON;
    function __publishSiteTranslations(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.multilingual.genericconverter.v1.entity_mapper',
            method: 'POST',
            methodFqn: 'wix.multilingual.editoradapter.v1.EditorAdapter.PublishSiteTranslations',
            url: resolveWixMultilingualEditoradapterV1EditorAdapterUrl({
                protoPath: '/v1/publish_translations',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __publishSiteTranslations.fromReq = fromReq;
    return __publishSiteTranslations;
}
publishSiteTranslations.__isAmbassador = true;
/** Update a mapper of create one if it doesn't exist */
export function createOrUpdateMapper(payload) {
    var _a = serializer(_createOrUpdateMapperRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createOrUpdateMapperResponse, {}).fromJSON;
    function __createOrUpdateMapper(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.multilingual.genericconverter.v1.entity_mapper',
            method: 'POST',
            methodFqn: 'wix.multilingual.editoradapter.v1.EditorAdapter.CreateOrUpdateMapper',
            url: resolveWixMultilingualEditoradapterV1EditorAdapterUrl({
                protoPath: '/v1/mapper',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createOrUpdateMapper.fromReq = fromReq;
    return __createOrUpdateMapper;
}
createOrUpdateMapper.__isAmbassador = true;
/** Get mapper by entity type */
export function getMapper(payload) {
    var _a = serializer(_getMapperRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getMapperResponse, {}).fromJSON;
    function __getMapper(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.multilingual.genericconverter.v1.entity_mapper',
            method: 'GET',
            methodFqn: 'wix.multilingual.editoradapter.v1.EditorAdapter.GetMapper',
            url: resolveWixMultilingualEditoradapterV1EditorAdapterUrl({
                protoPath: '/v1/mapper',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getMapper.fromReq = fromReq;
    return __getMapper;
}
getMapper.__isAmbassador = true;
/** Delete a mapper from the service */
export function deleteMapper(payload) {
    var _a = serializer(_deleteMapperRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteMapperResponse, {}).fromJSON;
    function __deleteMapper(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.multilingual.genericconverter.v1.entity_mapper',
            method: 'DELETE',
            methodFqn: 'wix.multilingual.editoradapter.v1.EditorAdapter.DeleteMapper',
            url: resolveWixMultilingualEditoradapterV1EditorAdapterUrl({
                protoPath: '/v1/mapper',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteMapper.fromReq = fromReq;
    return __deleteMapper;
}
deleteMapper.__isAmbassador = true;
/** List all mappers known to service */
export function listMappers(payload) {
    var _a = serializer(_listMappersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listMappersResponse, {}).fromJSON;
    function __listMappers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.multilingual.genericconverter.v1.entity_mapper',
            method: 'GET',
            methodFqn: 'wix.multilingual.editoradapter.v1.EditorAdapter.ListMappers',
            url: resolveWixMultilingualEditoradapterV1EditorAdapterUrl({
                protoPath: '/v1/list',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listMappers.fromReq = fromReq;
    return __listMappers;
}
listMappers.__isAmbassador = true;
/** Stress test */
export function stressDm(payload) {
    var _a = serializer(_stressDMRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_stressDMResponse, {}).fromJSON;
    function __stressDm(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.multilingual.genericconverter.v1.entity_mapper',
            method: 'GET',
            methodFqn: 'wix.multilingual.editoradapter.v1.EditorAdapter.StressDM',
            url: resolveWixMultilingualEditoradapterV1EditorAdapterUrl({
                protoPath: '/v1/stress',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __stressDm.fromReq = fromReq;
    return __stressDm;
}
stressDm.__isAmbassador = true;
//# sourceMappingURL=http.impl.js.map